import Header from '../../components/common/header/index.vue'
import bottom from '../../components/common/bottom/index.vue'
import index from './component/index/index.vue'
import yldn from './component/yldn/index.vue'
import ztyj from './component/ztyj/index.vue'
import jpww from './component/jpww/index.vue'
import zmzj from './component/zmzj/index.vue'
import jgcg from './component/jgcg/index.vue'
import hsdt from './component/hsdt/index.vue'
export default {
  name: 'home',
  components: { Header, index, yldn, ztyj, jpww, zmzj, jgcg, hsdt, bottom },
  data () {
    return {
      naviList: [
        {
          name: '首页',
          value: 'home'
        },
        {
          name: '英烈档案',
          value: 'ylda'
        }, {
          name: '专题研究',
          value: 'ztyj'
        }, {
          name: '精品文物',
          value: 'jpww'
        }, {
          name: '专家成果',
          value: 'zmzj'
        }, {
          name: '机构成果',
          value: 'jgcg'
        }, {
          name: '红色动态',
          value: 'hsdt'
        }
      ],
      // 导航选中
      naviSelect: 'home',
      yldaTop: 0,
      ztyjTop: 0,
      jpwwTop: 0,
      zmzjTop: 0,
      jgcgTop: 0,
      hsdtTop: 0
    }
  },
  // 创建元素
  mounted () {
    this.getTop()
    window.addEventListener('scroll', this.handleScroll)
  },
  // 方法定义
  methods: {
    clickNavi (item) {
      if (item.value === 'home') {
        document.documentElement.scrollTop = 0
      } else {
        const height = document.getElementById(item.value).clientHeight
        const top = document.getElementById(item.value).offsetTop
        document.documentElement.scrollTop = height + top + 70
      }
    },

    getTop () {
      // 获取英烈档案高度
      const ylda = document.getElementById('ylda')
      this.yldaTop = ylda.clientHeight + ylda.offsetTop + 70
      // 获取专题研究高度
      const ztyj = document.getElementById('ztyj')
      this.ztyjTop = ztyj.clientHeight + ztyj.offsetTop + 70
      // 获取精品文物高度
      const jpww = document.getElementById('jpww')
      this.jpwwTop = jpww.clientHeight + jpww.offsetTop + 70
      // 获取专家成果高度
      const zmzj = document.getElementById('zmzj')
      this.zmzjTop = zmzj.clientHeight + zmzj.offsetTop + 70
      // 获取机构成果高度
      const jgcg = document.getElementById('jgcg')
      this.jgcgTop = jgcg.clientHeight + jgcg.offsetTop + 70
      // 获取红色动态高度
      const hsdt = document.getElementById('hsdt')
      this.hsdtTop = hsdt.clientHeight + hsdt.offsetTop + 70
      this.handleScroll()
    },

    handleScroll () {
      // 获取当前滚动的高度
      const top = document.documentElement.scrollTop
      // 判断滚动到的导航位置并显示
      if (top >= 0 && top < this.yldaTop) {
        this.naviSelect = 'home'
      } else if (top >= this.yldaTop && top < this.ztyjTop) {
        this.naviSelect = 'ylda'
      } else if (top >= this.ztyjTop && top < this.jpwwTop) {
        this.naviSelect = 'ztyj'
      } else if (top >= this.jpwwTop && top < this.zmzjTop) {
        this.naviSelect = 'jpww'
      } else if (top >= this.zmzjTop && top < this.jgcgTop) {
        this.naviSelect = 'zmzj'
      } else if (top >= this.jgcgTop && top < this.hsdtTop) {
        this.naviSelect = 'jgcg'
      } else if (top >= this.hsdtTop) {
        this.naviSelect = 'hsdt'
      }
      // 判断是否该显示搜索
      if (top >= 0 && top < 559) {
        this.$refs.jsIndex.isShowSearch(true)
      } else if (top >= 559) {
        this.$refs.jsIndex.isShowSearch(false)
      }
    }
  }
}
